import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import {CommonService} from "../../../../src/app/common/common.service";
import {CommonDataService} from "../../../../src/app/common/common-data.service";
import {AboutMeService} from "../../../../src/app/about-me/about-me.service";
import {ManageMailboxService} from "../../../../src/app/manage-mailbox/manage-mailbox-service";
import {ChangePasswordComponent} from "../../../../src/app/about-me/change-password/change-password.component";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import {FlexLayoutModule} from "@angular/flex-layout";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {HttpClientModule} from "@angular/common/http";
import {AppRoutingModule} from "./app-routing.module";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AuthService} from "../../../../src/app/common/auth.service";
import {InvoiceService} from "../../../../src/app/invoices/invoice.service";
import {CookieService} from "ngx-cookie-service";
import {OtpModule} from "../../../../src/app/otp/otp.module";

@NgModule({
  declarations: [
    AppComponent,
    ChangePasswordComponent
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatTooltipModule,
    HttpClientModule,
    MatSnackBarModule,
    MatDividerModule,
    MatToolbarModule,
    OtpModule
  ],
  providers: [
    CommonService,
    CommonDataService,
    AboutMeService,
    ManageMailboxService,
    AuthService,
    InvoiceService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
